import React, { useContext, useEffect, useRef, useState } from 'react'
import { io } from 'socket.io-client'
import Topbar from '../../components/topbar/Topbar'
import ChatBox from '../../components/chatBox/ChatBox'
import ChatMenu from '../../components/chatMenu/ChatMenu'
import ChatCurrent from '../../components/chatCurrent/ChatCurrent'
import { AuthContext } from '../../context/AuthContext'

import './messenger.css'
import { MessengerContext } from '../../context/MessengerContext'

function Messenger() {
  
  const SU = process.env.REACT_APP_SOCKET_URL
  
  const socket = useRef()
  const {user} = useContext(AuthContext)
  const [conversation, setConversation] = useContext(MessengerContext)

  useEffect(() => {
    socket.current = io(SU)
  }, [])

  useEffect(() => {
    socket.current.emit('addUser', user._id)
    socket.current.on('getUsers', (users) => {
      console.log(users)
      console.log(socket)
    })
  }, [user])

  return (
    <>
        <Topbar />
        <div className="messenger">
            <ChatMenu />
            <ChatBox socket={socket}/>
            {Object.keys(conversation.communicator).length !== 0 && <ChatCurrent />}
        </div>
    </>
  )
}

export default Messenger